import React from 'react';
import { useTranslation } from 'react-i18next';
import ReportForm from '../ReportForm';

const RecommendedStrategyDeviatedApplicationsReport:React.FC = () => {
    const { t } = useTranslation();

    return <ReportForm title={t('reports.RecommendedStrategyDeviatedApplications.title')} APIName="postRecommendedStrategyDeviatedApplicationsReport" savedFileName={t('reports.RecommendedStrategyDeviatedApplications.title')} />;
};

export default RecommendedStrategyDeviatedApplicationsReport;
